// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

import { platformAdminIdentityUserMemberships } from "./platform-admin-identity-user-memberships";

export const platformAdminIdentityUserWorkflows = {
  actions: {
    assignPlatformRole: "プラットフォームロール割当",
    createUser: "プラットフォームユーザーを作成",
    editUser: "プラットフォームユーザーを編集",
  },
  drawers: {
    authorization: "認可 · {name}",
    authorizationShort: "認可",
    userEdit: "プラットフォームユーザーを編集 · {name}",
    userEditShort: "プラットフォームユーザーを編集",
    ...platformAdminIdentityUserMemberships.drawers,
  },
  alerts: {
    userCreatePolicy:
      "プラットフォームユーザー作成後、初回ログイン時にパスワード変更が必要です。有効期限を設定した場合、期限後はログインとセッション更新が禁止されます。",
    userCreateApplicationRoles:
      "任意：プラットフォームユーザー作成後に「アプリロールマッピング」を1件ずつ作成します。一部失敗した場合は、ユーザー作成成功とマッピング失敗を分けて通知します。",
    userCreateOidcApplicationRoles:
      "任意：ユーザー作成後に「OIDC アプリロール認可」としてユーザー単位マッピングを作成します。現在このドロワーは airange-admin カタログのみ対応です。",
    userEditApplicationRoles:
      "保存時は先に基礎情報とプラットフォームロールを更新し、その後でユーザー級アプリロールマッピングを差分更新します。プラットフォームロール映射や基礎身分映射はここでは変更しません。",
    ...platformAdminIdentityUserMemberships.alerts,
  },
  confirms: {
    resetPasswordTitle: "プラットフォームユーザーのパスワードをリセット",
    resetPasswordDescription:
      "{username} のパスワードをリセットしますか？一時パスワードは今回のレスポンスでのみ表示されます。",
    kickoutTitle: "プラットフォームユーザーをログアウトさせる",
    kickoutDescription:
      "このユーザーの現在のセッションを即時失効させますか？再度サインインが必要になります。",
    batchDisableDescription: "{count} 件のユーザーを {status} に設定します",
    impersonateTitle: "プラットフォームユーザーを代理操作",
    impersonateDescription:
      "{username} として現在のプラットフォーム画面に入りますか？この操作は現在のプラットフォームフロントエンドにのみ適用され、いつでも終了できます。",
    updateUserStatusTitle: "プラットフォームユーザー状態を更新",
    updateUserStatusDescription: "{username} を {status} に更新しますか？",
    ...platformAdminIdentityUserMemberships.confirms,
  },
  messages: {
    userCreated: "プラットフォームユーザーを作成しました",
    userCreatedWithRoleMappings:
      "プラットフォームユーザーを作成し、{count} 件のアプリロールマッピングを作成しました",
    userCreatedWithPartialRoleMappings:
      "プラットフォームユーザーは作成しましたが、{failedCount} 件のアプリロールマッピングが失敗しました：{details}",
    userUpdated: "プラットフォームユーザーを更新しました",
    userUpdatedWithPartialRoleMappings:
      "プラットフォームユーザーは更新しましたが、{failedCount} 件のアプリロールマッピング更新が失敗しました：{details}",
    userMappingApplicationUnavailable: "アプリ未解決：{application} / {role}",
    userMappingCreateFailedForApp: "アプリロールマッピング失敗：{application} / {role}",
    userMappingDeleteFailedForApp: "アプリロールマッピング削除失敗：{application} / {role}",
    userCreateFailed: "プラットフォームユーザーの作成に失敗しました",
    userUpdateFailed: "プラットフォームユーザーの更新に失敗しました",
    userStatusUpdated: "プラットフォームユーザー状態を更新しました",
    userStatusUpdateFailed: "プラットフォームユーザー状態の更新に失敗しました",
    passwordReset: "プラットフォームユーザーのパスワードをリセットしました",
    passwordResetFailed: "プラットフォームユーザーのパスワードリセットに失敗しました",
    kickoutSuccess: "プラットフォームユーザーをログアウトさせました",
    kickoutFailed: "プラットフォームユーザーのログアウトに失敗しました",
    batchKickoutSuccess: "{count} 件のユーザーをログアウトさせました",
    batchKickoutAlreadyOffline: "{count} 件のユーザーは既にオフラインです",
    batchDisableSuccess: "{count} 件のユーザーを停止しました",
    batchDisableAlreadyInactive: "{count} 件のユーザーは既に無効です",
    batchSkippedCurrentUser: "現在のユーザー {count} 件をスキップしました",
    batchUsersNotFound: "{count} 件のユーザーが見つかりませんでした",
    impersonateFailed: "プラットフォームユーザーの代理操作開始に失敗しました",
    impersonateSelfDisabled: "自分自身は代理操作できません",
    impersonateInactiveDisabled: "無効なユーザーは代理操作できません",
    impersonationBanner:
      "{target}（{targetUsername}）として操作中です。元の管理者は {actor}（{actorUsername}）です。",
    temporaryPasswordVisibleOnce:
      "一時パスワードは今回のみ表示されます。直ちにコピーしてユーザーへ共有してください。次回ログイン時に変更が必要です。",
    noTargetUser: "対象ユーザーが選択されていません",
    usersPartialLoadFailed:
      "ユーザー一覧の読み込みに失敗しましたが、他の統合認証データは保持しました",
    ...platformAdminIdentityUserMemberships.messages,
  },
  forms: {
    userCreate: "プラットフォームユーザーを新規作成",
    userEdit: "プラットフォームユーザーを編集",
    userEditShort: "プラットフォームユーザーを編集",
    username: "ユーザー名",
    nickname: "ニックネーム",
    nicknamePlaceholder: "任意。未入力の場合はユーザー名を使用します",
    phone: "携帯番号",
    initialPassword: "初期パスワード",
    expiresAt: "有効期限",
    expiresAtPlaceholder: "任意。未入力なら長期有効です",
    applicationRoleMappings: "アプリロールマッピング",
    addApplicationRoleMapping: "アプリロールマッピングを追加",
    applicationRoleMappingItem: "マッピング #{index}",
    applicationAdminRole: "管理者（admin）",
    applicationPlatformAdminRole: "プラットフォーム管理者（platform_admin）",
    oidcApplicationRoleMappings: "ユーザーレベル OIDC アプリロール認可",
    addOidcApplicationRoleMapping: "OIDC アプリロール認可を追加",
    oidcApplicationRoleMappingItem: "OIDC マッピング #{index}",
    targetUser: "対象ユーザー",
    oidcApplicationOwner: "OIDC アプリ",
    platformRoleAuthorization: "プラットフォームロール認可",
    userLevelOidcApplicationRoleMappingsHint:
      "ここで管理するのはユーザーレベルの OIDC アプリロール認可のみです。プラットフォームロールやアプリ grant によって自動的に有効になるアクセス権はここには表示されません。airange-admin では多くの権限がプラットフォームロールから自動マッピングされるため、通常は重ねて個別付与する必要はありません。",
    duplicateAirangeAdminUserLevelAuthorizationHint:
      "現在のユーザーは airange-admin に自動マッピングされるプラットフォームロールをすでに持っています: {roles}。下で airange-admin に同名のユーザーレベルロールを付与しても、通常は重複認可です。",
    requiredUsername: "ユーザー名を入力してください",
    requiredInitialPassword: "初期パスワードを入力してください",
    requiredPlatformRoles: "少なくとも 1 つのプラットフォームロールを選択してください",
    requiredUserSubject: "ユーザーを選択してください",
    selectUserSubject: "ユーザーを選択",
    userSubjectEmpty: "ユーザー未選択",
    userSubjectPickerTitle: "ロールマッピングのユーザー主体を選択",
    userSubjectPickerEmpty: "選択可能な ID ユーザーがありません",
    requiredTargetOidcBusinessRole: "対象 OIDC 業務ロールを選択してください",
    requiredOidcApplicationOwner: "OIDC アプリを選択してください",
    targetOidcBusinessRole: "対象 OIDC 業務ロール",
    ...platformAdminIdentityUserMemberships.forms,
  },
} as const;
